import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

/**
 * Loading interceptor
 * Automatically shows/hides loading indicator for HTTP requests
 * 
 * Register in app.config.ts
 */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  // Skip loading for specific endpoints (optional)
  const skipLoading = req.headers.has('X-Skip-Loading');

  if (skipLoading) {
    // Remove the header so it doesn't get sent to the server
    const modifiedReq = req.clone({
      headers: req.headers.delete('X-Skip-Loading'),
    });
    return next(modifiedReq);
  }

  // Increment active requests
  loadingService.incrementRequests();

  // Decrement when request completes (success or error)
  return next(req).pipe(
    finalize(() => {
      loadingService.decrementRequests();
    })
  );
};


